import {useEffect} from "react";
import {usePage} from "@inertiajs/react";
import {useBasketStore} from "@/Stores/Site/Basket";

export default function useBasketProductsUpdate() {
    const {props} = usePage();
    const {basketProducts = []} = props;
    const setBasketProducts = useBasketStore(state => state.setBasketProducts);

    useEffect(() => {
        setBasketProducts(basketProducts);
    }, [basketProducts]);
}
